import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import VehicleContext, { useGetVehicleId } from '~/context/vdp/VehicleContext';
import fetchRecalls from '~/services/vdp/fetchRecalls';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetRecalls() {
  const {
    recalls: { setData, setError, setLoading }
  } = useContext(VehicleContext);
  const vehicleId = useGetVehicleId();

  useEffectWithController(
    controller => {
      setLoading();

      fetchRecalls(vehicleId, controller)
        .then(({ data }) => setData(data))
        .catch(
          generateErrorLogger(
            'Get recalls',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoading, vehicleId]
  );
}
